import { CompanyConfig } from '../onboarding-stepper/components/company-config-section/company-config'
import { InvitationSection } from '../onboarding-stepper/components/employees-invitation-section/employees-invitation'
import { PaymentSection } from '../onboarding-stepper/components/payment-section/payment-section'
import { ProjectCreationSection } from '../onboarding-stepper/components/project-creation/project-creation'
import { StepperKey } from '../onboarding-stepper/constants/auth.constants'
import { StepperConfig } from '../onboarding-stepper/types/stepper-config'

export const STEPPER_CONFIG: StepperConfig = new Map([
  [
    StepperKey.CompanyConfig,
    {
      step: 1,
      key: StepperKey.CompanyConfig,
      component: CompanyConfig,
      buttonText: 'onboarding.companyConfig.buttonNext',
      next: StepperKey.Payment,
    },
  ],
  [
    StepperKey.Payment,
    {
      step: 2,
      key: StepperKey.Payment,
      component: PaymentSection,
      buttonText: 'onboarding.payment.buttonNext',
      prev: StepperKey.CompanyConfig,
      next: StepperKey.ProjectCreation,
    },
  ],
  [
    StepperKey.ProjectCreation,
    {
      step: 3,
      key: StepperKey.ProjectCreation,
      component: ProjectCreationSection,
      buttonText: 'projectCreation.buttons.next',
      prev: StepperKey.Payment,
      next: StepperKey.Invitation,
    },
  ],
  [
    StepperKey.Invitation,
    {
      step: 4,
      key: StepperKey.Invitation,
      component: InvitationSection,
      buttonText: 'onboarding.buttons.invite',
      prev: StepperKey.ProjectCreation,
      next: null,
    },
  ],
])
